package one.healthium.log_food.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class FoodDto(
    @SerialName("product") val product: String,
    @SerialName("emoji") val emoji: String,
    @SerialName("description") val description: String,
    @SerialName("calories") val calories: Float,
    @SerialName("fat") val fat: Float,
    @SerialName("carbohydrates") val carbohydrates: Float,
    @SerialName("fiber") val fiber: Float,
    @SerialName("protein") val protein: Float,
    @SerialName("tablespoon") val tablespoon: Float? = null,
    @SerialName("cups") val cups: Float? = null,
    @SerialName("pieces") val pieces: Float? = null,
    @SerialName("isLiquid") val isLiquid: Boolean = false,
)
